<template>
    <main class="mt-8 sm:mt-16">

        <div v-if="place.menu && step == 0" class="fixed right-4 bottom-4 bg-primary rounded-full px-4 py-2">
            <a :href="place.menu" target="_blank" class="text-white font-semibold text-xs">{{ $t('steps.one.menu') }}</a>
        </div>

        <div v-if="step == 0" class="fixed left-4 bottom-4 px-4 py-2">
            <a v-if="$store.state.locale != 'en'" href="/?lang=en" class="font-semibold text-xs mr-2">English</a>
            <a v-if="$store.state.locale != 'es'" href="/?lang=es" class="font-semibold text-xs mr-2">Español</a>
            <a v-if="$store.state.locale != 'it'" href="/?lang=it" class="font-semibold text-xs">Italiano</a>
        </div>

        <div class="step container mx-auto px-4" v-if="step == 0">
            <h1 class="text-2xl sm:text-4xl" v-html="$t('steps.one.title')"></h1>
            <div class="flex flex-wrap items-start mt-16 sm:mt-24 justify-center cursor-pointer">
                <div class="w-1/2 lg:w-auto max-w-xs" v-if="hasService('breakfast')" @click="setType('breakfast')">
                    <div class="flex flex-wrap items-center py-4 sm:py-8 bg-secondary justify-center rounded-xl mx-2 mb-16 sm:mb-20 sm:mb-24">
                        <div class="w-full text-center -mt-16 sm:-mt-24">
                            <img src="@/assets/images/brunch.png" class="w-auto h-32 sm:h-48 sm:w-auto mx-auto">
                        </div>
                        <div class="w-full">
                            <strong class="text-lg sm:text-xl">{{ $t('steps.one.breakfast') }}</strong>
                        </div>
                    </div>
                </div>
                <div class="w-1/2 lg:w-auto max-w-xs" v-if="hasService('brunch')" @click="setType('brunch')">
                    <div class="flex flex-wrap items-center py-4 sm:py-8 bg-secondary justify-center rounded-xl mx-2 mb-16 sm:mb-20 sm:mb-24">
                        <div class="w-full text-center -mt-16 sm:-mt-24">
                            <img src="@/assets/images/brunch.png" class="w-auto h-32 sm:h-48 sm:w-auto mx-auto">
                        </div>
                        <div class="w-full">
                            <strong class="text-lg sm:text-xl">{{ $t('steps.one.brunch') }}</strong>
                        </div>
                    </div>
                </div>
                <div class="w-1/2 lg:w-auto max-w-xs" v-if="hasService('lunch')" @click="setType('lunch')">
                    <div class="flex flex-wrap items-center py-4 sm:py-8 bg-secondary justify-center rounded-xl mx-2 mb-16 sm:mb-20 sm:mb-24">
                        <div class="w-full text-center -mt-16 sm:-mt-24">
                            <img src="@/assets/images/pranzo.png" class="w-auto h-32 sm:h-48 sm:w-auto mx-auto">
                        </div>
                        <div class="w-full">
                            <strong class="text-lg sm:text-xl">{{ $t('steps.one.lunch') }}</strong>
                        </div>
                    </div>
                </div>
                <div class="w-1/2 lg:w-auto max-w-xs" v-if="hasService('aper')" @click="setType('aper')">
                    <div class="flex flex-wrap items-center py-4 sm:py-8 bg-secondary justify-center rounded-xl mx-2 mb-16 sm:mb-20 sm:mb-24">
                        <div class="w-full text-center -mt-16 sm:-mt-24">
                            <img src="@/assets/images/aperitivo.png" class="w-auto h-32 sm:h-48 sm:w-auto mx-auto">
                        </div>
                        <div class="w-full">
                            <strong class="text-lg sm:text-xl">{{ $t('steps.one.aper') }}</strong>
                        </div>
                    </div>
                </div>
                <div class="w-1/2 lg:w-auto max-w-xs" v-if="hasService('dinner')" @click="setType('dinner')">
                    <div class="flex flex-wrap items-center py-4 sm:py-8 bg-secondary justify-center rounded-xl mx-2 mb-16 sm:mb-20 sm:mb-24">
                        <div class="w-full text-center -mt-16 sm:-mt-24">
                            <img src="@/assets/images/cena.png" class="w-auto h-32 sm:h-48 sm:w-auto mx-auto">
                        </div>
                        <div class="w-full">
                            <strong class="text-lg sm:text-xl">{{ $t('steps.one.dinner') }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="step container mx-auto px-4 xl:px-32 text-center" v-if="step == 1">
            <h1 class="text-2xl lg:text-4xl" v-html="$t('steps.two.title')"></h1>
            <Swiper class="mt-12" :min="place.min" :max="place.max" :value="num" @change="setNum" />
        </div>
        <div class="step container mx-auto px-4 xl:px-32 text-center" v-if="step == 2">
            <h1 class="text-2xl lg:text-4xl" v-html="$t('steps.three.title')"></h1>
            <SwiperDate :min="minDate" :max="maxDate" :value="date" :enabled="!slotsLoading" @change="setDate" class="mt-12 lg:hidden" />
            <div class="flex flex-wrap mt-6 lg:mt-16 justify-center">
                <div class="hidden lg:flex lg:w-1/3 pr-2">
                    <div class="calendar bg-secondary rounded-lg p-6">
                        <div class="overlay absolute w-full h-full -m-6 z-10 bg-white opacity-50" v-if="slotsLoading"></div>                        
                        <v-date-picker color="blue" :value="date" v-model="date" :min-date="minDate.toDate()" :max-date="maxDate.toDate()"/>
                    </div>
                </div>
                <div class="w-full lg:w-2/3 relative">     
                	<div class="w-full bg-secondary rounded-lg p-6 text-center" v-if="slotsLoading">           	
                		<LoaderIco class="inline-block w-6 ml-3 text-primary"></LoaderIco>
                		<div class="text-sm mt-2">{{ $t('steps.three.loading') }}</div>
                	</div>
                    <div class="w-full bg-secondary rounded-lg p-6 text-center" v-else-if="!isServiceAvailableOnSelectedDate"> 
                        <div class="text-sm mt-2 font-semibold">{{ $t('steps.three.unavailable',[ $moment(date).format('dddd')]) }}</div>
                    </div>
                    <div class="w-full bg-secondary rounded-lg p-6" v-else>
                        <div class="flex flex-wrap mb-3">
                            <div class="w-full text-left">
                                <h3 class="text-xl font-medium">{{ displayType }}</h3>
                                <p class="text-sm">{{ $t('steps.three.available', [slots[0], slots[slots.length - 1]]) }}</p>
                            </div>
                        </div>
                        <div class="grid grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
                            <div class="btn-radio" v-for="t, i in slots" :key="i">
                                <input type="radio" name="slot" v-model="time" :id="`s${i}`" :value="t" :disabled="!availableSlots[t].length">
                                <label :for="`s${i}`">
                                    <ArrowRightIco class="ico w-6 h-6" /> {{ t }}
                                </label>
                            </div>
                        </div>
                        <hr class="border-primary border-opacity-40 mt-4" />
                        <p class="text-sm text-left mt-5">{{ $t('steps.three.table_preference') }}</p>
                        <div class="flex flex-wrap justify-center items-center mt-3">
                            <div class="flex-grow btn-radio no-circle mr-2">
                                <input type="radio" name="env" v-model="env" :id="`int`" value="int" :disabled="!availableEnv('int')">
                                <label :for="`int`"><span class="hidden sm:inline-block">{{ $t('steps.three.table') }}</span> {{ $t('steps.three.int') }}</label>
                            </div>
                            <div class="flex-grow btn-radio no-circle">
                                <input type="radio" name="env" v-model="env" :id="`ext`" value="ext" :disabled="!availableEnv('ext')">
                                <label :for="`ext`"><span class="hidden sm:inline-block">{{ $t('steps.three.table') }}</span> {{ $t('steps.three.ext') }}</label>
                            </div>
                        </div>

                        <small v-if="time && showDurationMessage" class="mt-5 block">{{ $t('steps.three.duration',[tableAvailableUntil]) }}</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="step container mx-auto px-4 xl:px-32 text-center" v-if="step == 3">
            <h1 class="text-3xl lg:text-4xl" v-html="$t('steps.four.title')"></h1>
            <div class="w-full flex flex-wrap mt-10">
                <div class="w-full md:w-auto md:flex-grow py-4 bg-secondary rounded-lg md:mr-4 mb-2 md:mb-0">
                    <div class="flex items-center">
                        <div class="w-full text-center sm:text-xl">
                            <span>{{ $t('steps.four.booking') }}
                                <strong v-if="type == 'breakfast'">{{ $t('steps.four.breakfast') }}</strong>
                                <strong v-if="type == 'brunch'">{{ $t('steps.four.brunch') }}</strong>
                                <strong v-if="type == 'lunch'">{{ $t('steps.four.lunch') }}</strong>
                                <strong v-if="type == 'aper'">{{ $t('steps.four.aper') }}</strong>
                                <strong v-if="type == 'dinner'">{{ $t('steps.four.dinner') }}</strong>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="flex-grow py-4 bg-secondary rounded-lg mr-4">
                    <div class="flex items-center">
                        <div class="w-full text-center">
                            <span class="sm:text-xl" v-html="$t('steps.four.date', [$moment(date).format('D MMMM'), time])"></span>
                        </div>
                    </div>
                </div>
                <div class="py-4 bg-secondary rounded-lg">
                    <div class="flex items-center">
                        <div class="w-full text-center px-6 relative">
                            <span class="sm:text-xl text-center block pr-5"><strong>{{ num }} </strong>
                                <PeopleIco class="text-primary opacity-80 h-6 w-6 absolute right-4 top-0 md:top-3" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8 sm:mt-10">
                <div class="form-group">
                    <input class="w-full" type="text" :placeholder="$t('steps.four.form.name')" v-model="name">
                </div>
                <div class="form-group">
                    <input class="w-full" type="text" :placeholder="$t('steps.four.form.surname')" v-model="surname">
                </div>
                <div class="form-group">
                    <vue-tel-input v-model="phone" @validate="validatePhone"></vue-tel-input>
                </div>
                <div class="form-group">
                    <input class="w-full" type="email" :placeholder="$t('steps.four.form.email')" v-model="email">
                </div>
            </div>
            <div class="flex flex-wrap mt-8 sm:mt-10">
                <div class="w-full sm:w-1/2 flex justify-between items-center mb-4 sm:mb-10" v-for="option, index in options" :key="index">
                    <label class="inline-flex items-center cursor-pointer">
                        <input type="checkbox" v-model="requests[index]">
                        {{ option }}
                    </label>
                </div>
            </div>

            <p v-if="!time" class="text-red-700 font-semibold py-2">{{ $t('steps.four.time_not_available') }}</p>

            <small v-if="time" class="italic leading-4 block text-left lg:text-center">{{ $t('steps.four.privacy') }}</small>
            <div class="w-full text-center mt-4">
                <button v-if="time" type="button" class="inline-block rounded-lg py-4 px-10 bg-primary text-white text-xl sm:text-2xl shadow-lg font-light focus:outline-none" @click="submit()" :disabled="loading">{{ $t('steps.four.confirm') }} <LoaderIco class="inline-block w-6 ml-3" v-if="loading"></LoaderIco></button>
                <a href="#" @click="back()" class="block p-4 text-primary mx-6 text-lg">
                    <ArrowLeftIco class="h-6 w-6 inline-block" /> {{ $t('back') }}
                </a>
            </div>
        </div>
        <div class="step container mx-auto px-4 xl:px-32 text-left" v-if="step == 4">
            <div class="bg-secondary p-4 rounded-xl">
                <h1 v-if="place.autobooking" class="text-2xl sm:text-4xl font-bold text-left" v-html="$t('steps.five.confirmed')"></h1>
                <h1 v-else class="text-2xl sm:text-4xl font-bold text-left leading-7" v-html="$t('steps.five.pending')"></h1>
                <small v-if="place.autobooking" class="block leading-1 sm:mt-1 sm:text-lg">{{ $t('steps.five.confirmed_email') }}</small>
                <small v-else class="block leading-1 sm:mt-1 sm:text-lg">{{ $t('steps.five.pending_email') }}</small>
                <hr class="border-primary border-opacity-40 my-4" />
                <small class="block leading-1 sm:mt-1 sm:text-lg">{{ $t('steps.five.place') }}</small>
                <strong class="block leading-1 text-sm sm:text-lg">{{ place.name }}</strong>
                <small class="block leading-1 sm:mt-1 sm:text-lg mt-2">{{ $t('steps.five.booking') }}</small>
                <strong class="block leading-1 text-sm sm:text-lg" v-if="booking">#{{ booking.id }}</strong>
                <small class="block leading-1 sm:mt-1 sm:text-lg mt-2">{{ $t('steps.five.name') }}</small>
                <strong class="block leading-1 text-sm sm:text-lg">{{ name }} {{ surname }}</strong>
                <small class="block leading-1 sm:mt-1 sm:text-lg mt-2">{{ $t('steps.five.people') }}</small>
                <strong class="block leading-1 text-sm sm:text-lg">{{ num }}</strong>
                <small class="block leading-1 sm:mt-1 sm:text-lg mt-2">{{ $t('steps.five.date_time') }}</small>
                <strong class="block leading-1 text-sm sm:text-lg">{{ date | moment('D MMMM') }} {{ $t('steps.five.at') }} {{ time }}</strong>
            </div>
        </div>
        <div class="actions container text-center mt-6 sm:mt-12 mx-auto">
            <a v-if="step > 0 && step < 3" href="#" @click="back()" class="hidden md:inline-block border xl:border-2 font-medium border-primary rounded-xl px-8 xl:px-16 py-4 text-primary text-xl sm:text-2xl mr-4 hover:bg-primary hover:text-white">{{ $t('back') }}</a>
            <a v-if="step > 0 && step < 3" href="#" @click="next()" class="hidden md:inline-block border xl:border-2 font-medium border-primary rounded-xl px-8 xl:px-16 py-4 text-primary text-xl sm:text-2xl hover:bg-primary hover:text-white">{{ $t('next') }}</a>
            <button v-if="step > 0 && step < 3" @click="back()" class="inline-block md:hidden border border-primary rounded-full p-4 text-primary mx-6">
                <ArrowLeftIco class="h-6 w-6" />
            </button>
            <button v-if="step > 0 && step < 3" @click="next()" class="inline-block md:hidden border border-primary rounded-full p-4 text-white bg-primary mx-6">
                <ArrowRightIco class="h-6 w-6" />
            </button>
        </div>
    </main>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Progress from '@/components/Progress.vue'
import Swiper from '@/components/Swiper.vue'
import SwiperDate from '@/components/SwiperDate.vue'
import ArrowLeftIco from '@/svg/arrow-left.vue'
import ArrowRightIco from '@/svg/arrow-right.vue'
import LoaderIco from '@/svg/loader.vue'
import InfoIco from '@/svg/info.vue'
import PeopleIco from '@/svg/people.vue'

import { db } from '@/db'

export default {
    components: { Progress, Swiper, SwiperDate, ArrowLeftIco, ArrowRightIco, LoaderIco, InfoIco, PeopleIco },
    data() {
        return {
            step: 0,
            date: new Date(),
            type: null,
            num: null,
            time: null,
            env: null,
            // dates
            minDate: (new this.$moment()),
            maxDate: (new this.$moment()).add(40, 'days'),
            availableSlots: {},
            slotsLoading: false,
            // user
            name: '',
            surname: '',
            email: '',
            phone: '',
            phonePrefix: '',
            requests: [],
            // validatiom
            isPhoneValid: false,
            // errors
            errors: [],
            loading: false,
            // ref
            booking: null
        }
    },
    mounted() {
    	this.num = this.place.min
        this.options.map((option, i) => {
            this.requests[i] = false
        })
    },
    watch: {
        date: function(newVal, oldVal) {            
            this.getAvailableSlots()
        }
    },
    computed: {
        ...mapGetters(["place", "services", "options"]),

        slots() {
            return this.services[this.type].slots
        },

        displayType() {
            if (this.type == 'breakfast') return this.$t('steps.one.breakfast')
            if (this.type == 'brunch') return this.$t('steps.one.brunch')
            if (this.type == 'lunch') return this.$t('steps.one.lunch')
            if (this.type == 'aper') return this.$t('steps.one.aper')
            if (this.type == 'dinner') return this.$t('steps.one.dinner')
        },

        isServiceAvailableOnSelectedDate() {
            const weekDay = this.$moment(this.date).isoWeekday().toString()            
            return this.services[this.type].days.includes(weekDay)
        },

        duration() {
            return this.services[this.type].duration
        },

        capacity() {
            return this.services[this.type].capacity
        },

        showDurationMessage() {
            return this.services[this.type].durationAlert
        },

        tableAvailableUntil() {
            if(this.time) {
                return this.$moment(this.time, "hh:mm").add(this.duration, 'm').format('HH:mm')
            }
        }

    },
    methods: {
        async getAvailableSlots() {                    
            if(!this.isServiceAvailableOnSelectedDate) {
                this.availableSlots = {}
                return
            }

            const date = (new this.$moment(this.date)).format('YYYY-MM-DD')
            const url = 'https://europe-west3-prenota-31090.cloudfunctions.net/slots'
            //const url = 'http://localhost:5001/prenota-31090/europe-west3/slots'
            // const url = process.env.NODE_ENV != 'development' ?
            //             'https://europe-west3-prenota-31090.cloudfunctions.net/slots' :
            //             'http://localhost:5001/prenota-31090/europe-west3/slots'

            this.slotsLoading = true            
            const params = {
                id: this.place.id,
                num: this.num,
                date,
                duration: this.duration,
                capacity: this.capacity
            }
            const json = await this.axios.get(url,{ params })
            this.slotsLoading = false
            this.availableSlots = json.data
            // unset time, env if not available on new date      
            if(this.time && !this.availableSlots[this.time].length) {                      
                this.env = null
                this.time = null                
            }
        },
        hasService(type) {
            return this.services[type]?.days.length && this.services[type]?.slots.length
        },        
        setType(type) {
            // reset time if changing service
            if(this.type && this.type != type) 
                this.time = null

            this.type = type
            this.next()
        },
        availableEnv(env) {
            let avalable = false
            const slot = this.availableSlots[this.time] || []
            slot.map(s => {
                if(s.env == env) avalable = true
            })
            return avalable
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validatePhone(phone) {
            this.isPhoneValid = phone.valid || false
            this.phonePrefix = phone.countryCallingCode || ''
        },
        validate() {
            this.errors = [];
            if (this.name.length == 0) { this.$toasted.info(this.$t('validation.name'));
                this.errors.push('name'); }
            if (this.surname.length == 0) { this.$toasted.info(this.$t('validation.surname'));
                this.errors.push('surname'); }
            if (this.phone.length == 0) { this.$toasted.info(this.$t('validation.phone'));
                this.errors.push('name'); }
            if (!this.validateEmail(this.email)) { this.$toasted.info(this.$t('validation.email'));
                this.errors.push('email'); }
            if (!this.isPhoneValid) { this.$toasted.info(this.$t('validation.phone_valid'));
                this.errors.push('phone'); }
        },
        setNum(num) {
            this.num = num
        },
        setDate(date) {
            this.date = date
        },
        setSlotSelected(date, slot, index) {
            this.date = date
            this.time = slot.slot
        },
        next() {
        	if (this.step == 1 && !this.availableSlots.length) {
                this.getAvailableSlots()
            }
            if (this.step == 2) {
                if (!this.time) { this.$toasted.info(this.$t('validation.slot')); return false; }
            }
            this.step++
            window.scrollTo(0, 0)
        },
        back() {
            this.step--
            window.scrollTo(0, 0)
        },
        async submit() {
            this.validate()
            if (this.errors.length == 0) {
                this.loading = true
                const time = this.time.split(':')
                const date = (new this.$moment(this.date)).set({ h: time[0], m: time[1], s: 0, ms: 0 }).toDate()
                let booking = {
                    uid: this.place.uid,
                    type: this.type,
                    num: this.num,
                    date: date,
                    time: this.time,
                    duration: this.duration ?? 1,
                    env: this.env,
                    name: this.name,
                    surname: this.surname,
                    email: this.email,
                    phone: `+${this.phonePrefix} ${this.phone}`,
                    status: 'pending',
                    source: 'web',
                    created: new Date(),
                    locale: this.$store.state.locale,
                    options: []
                }
                // assign first table available (lowest capacity) if autobooking is active
                if(this.place.autobooking) {
                    // reload available slots to avoid collisions
                    await this.getAvailableSlots()
                    if(this.time) {
                        this.availableSlots[this.time].map(table => {
                            if(!booking.table && (!this.env || table.env == this.env)) {
                                booking.table = table.id
                                booking.status = 'accepted'                            
                            }
                        })             
                    }
                    else {
                        this.loading = false
                        return false
                    }                                                   
                }

                this.requests.map((req, i) => {
                    if (req) booking.options.push(this.options[i])
                })
                this.$store.dispatch("createBooking", booking).then(res => {
                    this.booking = res
                    this.step++
                }).catch(res => {
                    this.loading = false
                    this.$toasted.error(this.$t('errors.server'));
                })
            }
        }
    }
}
</script>